import { render, staticRenderFns } from "./ReportList2.vue?vue&type=template&id=73dd9f71&"
import script from "./ReportList2.vue?vue&type=script&lang=js&"
export * from "./ReportList2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports